import { rootStore } from 'stores/root/RootStore';
import BaseStore from 'stores/BaseStore';

export function registerStore<T extends BaseStore>(
  storeName: string,
  store: T,
): void {
  // storeName을 constructor.name 에서 얻으면 uglify 이후 문제 생김
  // console.log('storeName', storeName);

  if (storeName in rootStore.stores) {
    // throw new Error('store already registered');
  } else {
    rootStore.stores[storeName] = store;
  }
}
